angular.module('GlobalHelpersModule').filter "reverse", ->
  (items) ->
    items.slice().reverse()